import { createThemedUseStyles } from "theme";

export default createThemedUseStyles((theme) => ({
  batchTypesArea: {},
  batchTypesHeader: {},
  batchTypesList: {}
}));
